
'use client';

import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function WhoWeArePageAnimator() {

  useEffect(() => {
    const timer = setTimeout(() => {
        const storyTl = gsap.timeline({
            scrollTrigger: {
                trigger: '#our-story',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        });
        storyTl
            .to('.gsap-wwa-story-text', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', delay: 0.2 })
            .to('.gsap-wwa-story-image', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6");
        
        gsap.to('.gsap-wwa-mission-card', {
            scrollTrigger: {
                trigger: '#mission-vision',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.2,
            ease: 'power3.out',
            delay: 0.2
        });

        gsap.to('.gsap-wwa-profile-card', {
            scrollTrigger: {
                trigger: '#company-profile',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.2,
            ease: 'power3.out',
            delay: 0.2
        });

        const teamTl = gsap.timeline({
            scrollTrigger: {
                trigger: '#team',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        });
        teamTl
            .to('.gsap-wwa-team-title', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' })
            .to('.gsap-wwa-team-card', { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out', stagger: 0.2 }, "-=0.5");

        const milestonesTl = gsap.timeline({
            scrollTrigger: {
                trigger: '#milestones',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        });
        milestonesTl
            .to('.gsap-wwa-milestones-title', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' })
            .to('.gsap-wwa-milestones-carousel', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6");

    }, 0);


    return () => {
      clearTimeout(timer);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return null;
}
